// @flow
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { localeReducer } from 'react-localize-redux';
import meReducer from './meReducer';
import envReducer from './envReducer';
import wizardReducer from './wizardReducer';
import projectReducer from './projectReducer';
import plansReducer from './plansReducer';
import gtmReducer from './gtmReducer';
import datapointsReducer from './datapointsReducer';
import adminReducer from './adminReducer';

export default combineReducers({
  locale: localeReducer,
  routing: routerReducer,
  me: meReducer,
  wizard: wizardReducer,
  project: projectReducer,
  env: envReducer,
  gtm: gtmReducer,
  plansData: plansReducer,
  datapoints: datapointsReducer,
  admin: adminReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js